/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { GetProjectEmployeeResponse } from '../models/get-project-employee-response';
import { CreateProjectEmployeeRequest } from '../models/create-project-employee-request';
@Injectable({
  providedIn: 'root',
})
class ProjectEmployeeService extends __BaseService {
  static readonly ProjectEmployeeGetAllPath = '/ProjectEmployee/GetAll';
  static readonly ProjectEmployeeGetByIdPath = '/ProjectEmployee/GetById';
  static readonly ProjectEmployeeCreatePath = '/ProjectEmployee/Create';
  static readonly ProjectEmployeeCreateRangePath = '/ProjectEmployee/CreateRange';
  static readonly ProjectEmployeeDeletePath = '/ProjectEmployee/Delete';
  static readonly ProjectEmployeeDeleteRangePath = '/ProjectEmployee/DeleteRange';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }
  ProjectEmployeeGetAllResponse(): __Observable<__StrictHttpResponse<Array<GetProjectEmployeeResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ProjectEmployee/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<GetProjectEmployeeResponse>>;
      })
    );
  }  ProjectEmployeeGetAll(): __Observable<Array<GetProjectEmployeeResponse>> {
    return this.ProjectEmployeeGetAllResponse().pipe(
      __map(_r => _r.body as Array<GetProjectEmployeeResponse>)
    );
  }

  /**
   * @param Id undefined
   */
  ProjectEmployeeGetByIdResponse(Id?: string): __Observable<__StrictHttpResponse<GetProjectEmployeeResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (Id != null) __params = __params.set('Id', Id.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ProjectEmployee/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<GetProjectEmployeeResponse>;
      })
    );
  }
  /**
   * @param Id undefined
   */
  ProjectEmployeeGetById(Id?: string): __Observable<GetProjectEmployeeResponse> {
    return this.ProjectEmployeeGetByIdResponse(Id).pipe(
      __map(_r => _r.body as GetProjectEmployeeResponse)
    );
  }

  /**
   * @param request undefined
   */
  ProjectEmployeeCreateResponse(request: CreateProjectEmployeeRequest): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ProjectEmployee/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProjectEmployeeCreate(request: CreateProjectEmployeeRequest): __Observable<Blob> {
    return this.ProjectEmployeeCreateResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param request undefined
   */
  ProjectEmployeeCreateRangeResponse(request: Array<CreateProjectEmployeeRequest>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/ProjectEmployee/CreateRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param request undefined
   */
  ProjectEmployeeCreateRange(request: Array<CreateProjectEmployeeRequest>): __Observable<Blob> {
    return this.ProjectEmployeeCreateRangeResponse(request).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param id undefined
   */
  ProjectEmployeeDeleteResponse(id?: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (id != null) __params = __params.set('id', id.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/ProjectEmployee/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param id undefined
   */
  ProjectEmployeeDelete(id?: string): __Observable<Blob> {
    return this.ProjectEmployeeDeleteResponse(id).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param ids undefined
   */
  ProjectEmployeeDeleteRangeResponse(ids: Array<string>): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = ids;
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/ProjectEmployee/DeleteRange`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param ids undefined
   */
  ProjectEmployeeDeleteRange(ids: Array<string>): __Observable<Blob> {
    return this.ProjectEmployeeDeleteRangeResponse(ids).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ProjectEmployeeService {
}

export { ProjectEmployeeService }
